// extracted by mini-css-extract-plugin
export default {"Text":"InputLabel-module__Text--xY8s7","Box":"InputLabel-module__Box--dyD6H","Box_1":"InputLabel-module__Box_1--HuT0E"};